/* eslint-disable */
import { IReportDefinitionsService, ReportDefinition, ComponentType, MultiplicityType } from "@sa/rep-core";
import { DataType } from "@sa/rep-common";
import {
  IMDMDataApiService,
  IMDMMetadataApiService,
  IDictionariesCacheService,
  DictionaryDefinition,
  MDMQuery,
  MDMResult,
  DictionaryItem,
} from "@sa/rep-mdm";
import { getJSON, post } from "../../../http";

export interface IDictionaryServiceConfig {
  baseUrl: string;
}

export class DictionariesAPIService implements IMDMDataApiService, IMDMMetadataApiService {
  private _cache = new Map<string, any>();
  protected _baseUrl: string;

  constructor(config: IDictionaryServiceConfig) {
    this._baseUrl = config.baseUrl;
  }

  async get(id: string[]): Promise<DictionaryDefinition[]> {
    const promises: Promise<DictionaryDefinition>[] = [];
    for (const dictionaryId of id) {
      const cache = this._cache.get(dictionaryId);
      if (cache) {
        promises.push(cache);
      } else {
        const prms = getJSON<DictionaryDefinition>(`${this._baseUrl}/dimensions/${dictionaryId}/model`);
        this._cache.set(dictionaryId, prms);
        promises.push(prms);
      }
    }
    return Promise.all(promises);
  }

  async query(id: string, query: MDMQuery): Promise<MDMResult> {
    const hash = `${id}#${JSON.stringify(query)}}`;
    const cache = this._cache.get(hash);
    if (cache) {
      return await cache;
    }
    query.ids = query.ids ? query.ids.map(Number) : [];
    query.attributes = query.attributes || [];
    const json = post(`${this._baseUrl}/dimensions/${id}/items`, query).then((x) => x.json());
    this._cache.set(hash, json);
    const result = await json as MDMResult;
    return result;
  }
}

export class DictionariesCacheService implements IDictionariesCacheService {
  private _cache = new Map<string, any>();

  getDefinition(id: string): DictionaryDefinition | undefined {
    return this._cache.get(id);
  }
  setDefinition(definition: DictionaryDefinition): void {
    this._cache.set(definition.id, definition);
  }
  setItems(dictionaryHash: string, items: DictionaryItem[]): void {
    this._cache.set(dictionaryHash, items);
  }
  getItems(dictionaryHash: string, ids: string[]): DictionaryItem[] {
    return this._cache.get(dictionaryHash)?.filter((x) => ids.includes(x.id)) || [];
  }
  invalidateData(dictionaryHash?: string | undefined): void {
    if (dictionaryHash) {
      this._cache.delete(dictionaryHash);
    }
  }
  invalidateMetadata(dictionaryId?: string | undefined): void {
    if (dictionaryId) {
      this._cache.delete(dictionaryId);
    }
  }
}
